module.exports = __webpack_public_path__ + "static/media/coliseu_box_7.0f459674.jpg";